import { mergeMap, switchMap } from 'rxjs/operators';

import { catchApiError } from '@cbridge-packages/api';
import { ICollectorApiDependencySegment } from '@cbridge-packages/api-collector';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';

import { ExposureAction } from '../exposure.action';

type IDependencies = ICollectorApiDependencySegment;

export const loadDetailsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ExposureAction.loadDetails.started),
  switchMap((params) => {
    return dependencies.clApi.getExposureDetails(params).pipe(
      mergeMap((response) => {
        return [ExposureAction.loadDetails.done({ params, result: response.exposure })];
      }),
      catchApiError((error) => {
        return [
          ExposureAction.loadDetails.failed({ params, error: error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
